// import React, { useState, useEffect } from "react";
// import { Container, Col, Row, Form } from "react-bootstrap";
// import API_DOMAIN from "../config/config";
// import { FaMagnifyingGlass } from "react-icons/fa6";
// import { TableUI } from "../components/Tables";
// import { TextInputForm } from "../components/Forms";

// import { ClickButton } from "../components/Buttons";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// const WeeklySalaryTablehead = [
//   "No",
//   "Period",
//   "Total Gross",
//   "Total Recovery",
//   "Final Payable",
//   "Action",
// ];

// const WeeklySalary = () => {
//   const navigate = useNavigate();

//   const [weeklySalaryData, setWeeklySalaryData] = useState([]);
//   const [searchText, setSearchText] = useState("");

//   useEffect(() => {
//     fetchData();
//   }, [searchText]);

//   const fetchData = async () => {
//     try {
//       const response = await fetch(`${API_DOMAIN}/weekly_salary.php`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           action: "listWeeklySalary",
//         }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to fetch data");
//       }

//       const responseData = await response.json();
//       console.log(responseData);

//       if (responseData.head.code === 200) {
//         const transformedData = responseData.body.weekly_salary.map(
//           (ws, index) => {
//             const data = ws.salary_data || [];
//             const totalGross = data.reduce(
//               (sum, s) => sum + (s.totalGross || 0),
//               0
//             );
//             const totalRecovery = data.reduce(
//               (sum, s) => sum + (s.advanceDeductionThisWeek || 0),
//               0
//             );
//             const finalPayable = data.reduce(
//               (sum, s) => sum + (s.finalPayable || 0),
//               0
//             );
//             const period = `${formatDate(ws.from_date)} - ${formatDate(
//               ws.to_date
//             )}`;

//             return {
//               weekly_salary_id: ws.weekly_salary_id,
//               from_date: ws.from_date,
//               to_date: ws.to_date,
//               key: (index + 1).toString(),
//               period,
//               totalGross,
//               totalRecovery,
//               finalPayable,
//               data: data,
//             };
//           }
//         );

//         // Filter the data based on the searchText
//         const filteredData = transformedData.filter((item) =>
//           item.period.toLowerCase().includes(searchText.toLowerCase())
//         );

//         setWeeklySalaryData(filteredData); // Update the state with filtered data
//       } else {
//         throw new Error(responseData.head?.msg || "Unknown error");
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to load weekly salary data");
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = String(date.getFullYear()).slice(-2);
//     return `${day}/${month}/${year}`;
//   };

//   const handleSearch = (value) => {
//     setSearchText(value.trim());
//   };

//   return (
//     <div style={{ cursor: "pointer" }}>
//       <Container fluid>
//         <Row>
//           <Col lg="12" className="py-3">
//             <div className="main my-3">
//               <Row className="mx-2">
//                 <Col lg="12" md="12" xs="12" className="align-self-center">
//                   <h4 className="mb-0 fw-bold text-primary">Weekly Salary</h4>
//                 </Col>
//                 <Col lg="3">
//                   <div className=" mx-2">
//                     <TextInputForm
//                       placeholder={"Search by period"}
//                       onChange={(e) => handleSearch(e.target.value)}
//                       prefix_icon={<FaMagnifyingGlass />}
//                       labelname={"Search"}
//                     >
//                       {" "}
//                     </TextInputForm>
//                   </div>
//                 </Col>
//                 <Col
//                   lg="9"
//                   className="d-flex align-item-baseline justify-content-end"
//                 >
//                   <div className="text-end">
//                     <ClickButton
//                       label={<>Add New</>}
//                       onClick={() => navigate("/console/weeklysalary/create")}
//                     />
//                   </div>
//                 </Col>
//               </Row>
//               <div className="py-2 ">
//                 <TableUI
//                   headers={WeeklySalaryTablehead}
//                   body={weeklySalaryData}
//                   pageview={"yes"}
//                   type="weeklysalary"
//                   onDelete={fetchData}
//                 />
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </Container>
//     </div>
//   );
// };

// export default WeeklySalary;


import React, { useState, useEffect } from "react";
import { Container, Col, Row, Form } from "react-bootstrap";
import API_DOMAIN from "../config/config";
import { TableUI } from "../components/Tables";
import { ClickButton } from "../components/Buttons";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const WeeklySalaryTablehead = [
  "S.No",
  "Period",
  "Total Gross",
  "Total Recovery",
  "Final Payable",
  "Action",
];

const WeeklySalary = () => {
  const navigate = useNavigate();

  const [weeklySalaryData, setWeeklySalaryData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/weekly_salary.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "listWeeklySalaryByRange",
          from_date: fromDate,
          to_date: toDate,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.head.code === 200) {
        const transformedData = responseData.body.weekly_salary.map(
          (ws, index) => {
            const data = ws.salary_data || [];
            const totalGross = data.reduce(
              (sum, s) => sum + (parseFloat(s.totalGross) || 0),
              0
            );
            const totalRecovery = data.reduce(
              (sum, s) => sum + (parseFloat(s.advanceDeductionThisWeek) || 0),
              0
            );
            const finalPayable = data.reduce(
              (sum, s) => sum + (parseFloat(s.finalPayable) || 0),
              0
            );
            const period = `${formatDate(ws.from_date)} - ${formatDate(
              ws.to_date
            )}`;

            return {
              weekly_salary_id: ws.weekly_salary_id,
              from_date: ws.from_date,
              to_date: ws.to_date,
              key: (index + 1).toString(),
              period,
              totalGross: totalGross,
              totalRecovery: totalRecovery,
              finalPayable: finalPayable,
              data: data,
            };
          }
        );

        setWeeklySalaryData(transformedData);
      } else {
        throw new Error(responseData.head?.msg || "Unknown error");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load weekly salary data");
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}/${month}/${year}`;
  };

  const formatDateForHeader = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return date.toLocaleDateString('en-GB', options);
  };

  const generatePDF = () => {
    try {
      if (weeklySalaryData.length === 0) {
        toast.warning("No data available to generate PDF");
        return;
      }

      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });

      // Add title
      doc.setFontSize(20);
      doc.setTextColor(40, 40, 40);
      doc.text("WEEKLY SALARY REPORT", 105, 15, { align: 'center' });

      // Add date range
      doc.setFontSize(11);
      doc.setTextColor(100, 100, 100);
      const dateRange = fromDate && toDate 
        ? `Period: ${formatDateForHeader(fromDate)} to ${formatDateForHeader(toDate)}`
        : "All Periods";
      doc.text(dateRange, 105, 22, { align: 'center' });

      // Add report generated date
      doc.setFontSize(10);
      const generatedDate = new Date().toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
      doc.text(`Generated on: ${generatedDate}`, 105, 28, { align: 'center' });

      // Calculate totals for summary
      const totalGross = weeklySalaryData.reduce((sum, item) => sum + item.totalGross, 0);
      const totalRecovery = weeklySalaryData.reduce((sum, item) => sum + item.totalRecovery, 0);
      const totalPayable = weeklySalaryData.reduce((sum, item) => sum + item.finalPayable, 0);

      // Add summary section
      autoTable(doc, {
        startY: 35,
        head: [['Summary', 'Amount']],
        body: [
          ['Total Gross Salary', `${totalGross.toFixed(2)}`],
          ['Total Recovery', `${totalRecovery.toFixed(2)}`],
          ['Total Final Payable', `${totalPayable.toFixed(2)}`]
        ],
        theme: 'grid',
        headStyles: { fillColor: [66, 139, 202] },
        styles: { fontSize: 10 },
        margin: { left: 14, right: 14 }
      });

      // Prepare table data for PDF
      const tableData = weeklySalaryData.map((item, index) => [
        index + 1,
        item.period,
        `${item.totalGross.toFixed(2)}`,
        `${item.totalRecovery.toFixed(2)}`,
        `${item.finalPayable.toFixed(2)}`
      ]);

      // Add main table
      autoTable(doc, {
        startY: doc.lastAutoTable.finalY + 10,
        head: [['S.No', 'Period', 'Total Gross', 'Total Recovery', 'Final Payable']],
        body: tableData,
        theme: 'grid',
        headStyles: { fillColor: [41, 128, 185] },
        styles: { fontSize: 9 },
        margin: { left: 14, right: 14 },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 40 },
          2: { cellWidth: 35 },
          3: { cellWidth: 35 },
          4: { cellWidth: 35 },
        },
        didDrawPage: function (data) {
          // Footer
          doc.setFontSize(8);
          doc.setTextColor(150, 150, 150);
          doc.text(
            `Page ${data.pageNumber} of ${data.pageCount}`,
            data.settings.margin.left,
            doc.internal.pageSize.height - 10
          );
        }
      });

      // Save the PDF
      const fileName = fromDate && toDate
        ? `weekly-salary-${formatDate(fromDate)}-to-${formatDate(toDate)}.pdf`
        : `weekly-salary-all-periods-${new Date().getTime()}.pdf`;
      
      doc.save(fileName);
      
      toast.success("PDF report downloaded successfully!");
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF report");
    }
  };

  const handleDownloadPDF = () => {
    generatePDF();
  };

 

  // Format data for TableUI component
  const formatTableData = () => {
    return weeklySalaryData.map(item => ({
      ...item,
      totalGross: `${item.totalGross.toFixed(2)}`,
      totalRecovery: `${item.totalRecovery.toFixed(2)}`,
      finalPayable: `${item.finalPayable.toFixed(2)}`,
    }));
  };

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid>
        <Row>
          <Col lg="12" className="py-3">
            <div className="main my-3">
              <Row className="mx-2">
                <Col lg="12" md="12" xs="12" className="align-self-center">
                  <h4 className="mb-3 fw-bold text-primary">Weekly Salary Report</h4>
                </Col>
              </Row>
              
              {/* Date Filter Section */}
              <Row className="mx-2 mb-3">
                <Col lg="3" md="6" xs="12" className="mb-2">
                  <div className="mb-2">
                    <h6 className="fw-bold text-secondary">From Date</h6>
                    <Form.Control
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      placeholder="Select start date"
                    />
                  </div>
                </Col>
                <Col lg="3" md="6" xs="12" className="mb-2">
                  <div className="mb-2">
                    <h6 className="fw-bold text-secondary">To Date</h6>
                    <Form.Control
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      placeholder="Select end date"
                    />
                  </div>
                </Col>
                <Col lg="6" className="d-flex align-items-end justify-content-end">
                  <div className="mb-2 d-flex gap-3">
                   
                    <ClickButton
                      label={<>Download PDF Report</>}
                      onClick={handleDownloadPDF}
                      variant="outline-primary"
                      className="me-2"
                      disabled={weeklySalaryData.length === 0}
                    />
                    <ClickButton 
                      label={<>Add New</>}
                      onClick={() => navigate("/console/weeklysalary/create")}
                    />
                  </div>
                </Col>
              </Row>
              
              {/* Divider Line */}
              <hr className="mx-2" />
              
              {/* Table Section */}
              <div className="py-2">
                {isLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading weekly salary data...</p>
                  </div>
                ) : weeklySalaryData.length === 0 ? (
                  <div className="text-center py-5">
                    <p className="text-muted">No weekly salary data found for the selected period.</p>
                  </div>
                ) : (
                  <TableUI
                    headers={WeeklySalaryTablehead}
                    body={formatTableData()}
                    pageview={"yes"}
                    type="weeklysalary"
                    onDelete={fetchData}
                  />
                )}
              </div>
           
              
              {/* Download PDF Button at bottom */}
              {/* {weeklySalaryData.length > 0 && (
                <Row className="mx-2 mt-3">
                  <Col lg="12" className="text-center">
                    <ClickButton
                      label={<>Download PDF Report</>}
                      onClick={handleDownloadPDF}
                      variant="primary"
                      size="lg"
                    />
                  </Col>
                </Row>
              )} */}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default WeeklySalary;
